module.exports = __webpack_public_path__ + "img/view-icon-myt.025c3c3a.svg";